import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { formValidation } from '../../../utils/functions';
import Button from '../../button';
import FormFileInput from '../../form-file-input';
import CloseSVG from '../../../assets/svg/close.svg';
import FormInput from '../../form-input';
import FormSelectEmployee from '../../employees/form-select-employee';
import { useAddEmployeeDocument } from '../../../redux/document/hook/employee';
import Modal from '../modal';

function UploadEmployeeDocument({ isOpen, closeModal, refresh }) {
  const { mutateAsync: uploadFile, isLoading } = useAddEmployeeDocument();
  const {
    register,
    handleSubmit,
    errors,
    formState: { isValid },
  } = useForm({
    mode: 'onChange',
  });

  const [employee, setEmployee] = useState();
  const [employeeName, setEmployeeName] = useState();

  const [fileName, setFileName] = useState()

  async function submitForm(data) {

    const formData = new FormData();
    formData.append('file', data?.file[0]);
    formData.append('name', fileName);
    formData.append('employee_id', employee);

    await uploadFile(formData).then(() => {
      closeModal();
    });
  }

  return (
    <Modal
      scrollable={true}
      className='!max-w-[700px] !rounded-none'
      isOpen={isOpen}
      centered={true}
    >
      <form className='form overflow-auto' onSubmit={handleSubmit(submitForm)}>
        <div className='flex flex-col'>
          <div className='pl-8 pr-8 pt-4'>
            <div className='flex flex-row justify-between items-center'>
              <span className='header-4'>Upload Employee Document</span>
              <div className='cursor-pointer' onClick={() => closeModal()}>
                <img src={CloseSVG} alt='close' />
              </div>
            </div>
          </div>
        </div>
        <hr className='divider mb-2' />
        <div className='p-8 pt-1 flex flex-col px-8'>
          <div className='border bg-highlight p-2 rounded-md'>
            <FormSelectEmployee
              label={'Employee'}
              name='employee'
              placeholder='Select Employee'
              value={employee}
              empName={employeeName}
              setEmployee={setEmployee}
            />
          </div>
          <hr className='divider mt-2 mb-2' />
          <div className='w-full '>
            <FormInput
              label='File Name'
              name='name'
              type='text'
              placeholder={'Enter file name'}
              onInput={(e) => {
                setFileName(e.target.value)
              }}
              error={errors.name}
              errorMessage={errors.name && errors.name.message}
            />
          </div>
          <div className='flex flex-col justify-center items-start'>
            <span className='text-[13px] -mb-1 text-color-gray'>Select Document (Max. 3mb)</span>
            <FormFileInput
              multiSource={false}
              name={'file'}
              inputRef={register(formValidation('file', true))}
              accept='.png,.jpg,.jpeg,.pdf,.docx,.xlsx'
            />
          </div>

          <div className='w-full mt-[20px]'>
            <Button text='UPLOAD' type='submit' loading={isLoading} />
          </div>
        </div>
      </form>
    </Modal>
  );
}

export default UploadEmployeeDocument;
